import { ReactComponent as IceCreamIcon } from '@/Assets/icons/Illustrations/ice-cream.svg';
import { Button } from '../UI/Button/Button';
import { LINK_LOGIN } from '@/Utils/constants';

const WithoutPublicAccess = () => {
  const onButtonClick = () => {
    window.open(LINK_LOGIN, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='flex flex-col justify-center items-center h-full'>
      <div className='relative flex flex-col items-center h-3/4'>
        <IceCreamIcon />
        <p className='text-2xl font-extrabold text-midnight mb-4 mt-9'>You’ve lost the scoop!</p>
        <p className='text-ui mb-4'>Sorry, this sheet is no longer public.</p>
        <Button onClick={onButtonClick} iconName='' size='large' variant='solid' color='sunrise'>
          Login to Gigasheet
        </Button>
      </div>
    </div>
  );
};

export default WithoutPublicAccess;
